module.exports = __webpack_public_path__ + "static/media/your beauty-01.9040a1e3.png";